import React from 'react';
import { motion } from 'framer-motion';
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-cream-beige border-y border-gold-light" data-id="element-38" data-mp="uoh613eipwbq">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-39" data-mp="uqli48mkm1n3">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-6" data-id="element-40" data-mp="1icide8zyn6pk">
          What Taekwondo instructors are looking for is not more information.
        </h2>
        <p className="text-xl text-navy-medium mb-8" data-id="element-41" data-mp="18n8iymhn9bya">
          It is more structure. More clarity. A better way to turn what they already know into
          classes that feel organized, progressive and professional.
        </p>
        <div className="bg-cream-card border border-gold-light rounded-2xl p-8 shadow-sm text-lg text-ink space-y-2" data-id="element-42" data-mp="215vyznhsa0si">
          <p data-id="element-43" data-mp="1wbhyj6o9l3gz">
            With Taekwondo Instructor Ready, you do not have to begin every class from an empty
            page.
          </p>
          <p className="text-navy font-semibold" data-id="element-44" data-mp="28xpvven5l2x5">You already have the framework.</p>
          <p className="text-navy font-semibold" data-id="element-45" data-mp="1v61lbfsjymia">You already have the progression.</p>
          <p className="text-navy font-semibold" data-id="element-46" data-mp="1v3yuwunhmrd1">
            And with 150 ready-to-teach sessions, you already have the class.
          </p>
        </div>
      </motion.div>
    </section>;
}